import {
  FLASHCARD_COUNT,
  FLASHCARD_COUNT_REQUEST,
  FLASHCARD_INDEX,
  FLASHCARD_LIST_REQUEST,
  LIST_OF_CARDS,
  RESET_FLASHCARD,
  UPDATE_FLASHCARD,
  USER_FLASHCARD_DETAILS,
} from './ActionTypes';

export const getFlashCardCountRequest = (
  userId,
  success = () => {
  },
  errorSnackbar = () => {
  },
  value,
) => {
  return {
    type: FLASHCARD_COUNT_REQUEST,
    userId: userId,
    success,
    errorSnackbar,
    value,
  };
};

export const upDateFlashCardCount = (totalCards) => {
  return {
    type: FLASHCARD_COUNT,
    totalCards: totalCards,
  };
};

export const getFlashCardList = (
  flashcardDetails,
  //success = () => {},
  errorSnackbar = () => {
  },
  value,
) => {
  return {
    type: FLASHCARD_LIST_REQUEST,
    flashcardDetails: flashcardDetails,
    // success,
    errorSnackbar,
    value,
  };
};

export const ListOfCards = (cards) => {
  return {
    type: LIST_OF_CARDS,
    cards: cards,
  };
};

export const update_flashcard_details = (flashCardDetailArray) => {

  return {
    type: UPDATE_FLASHCARD,
    flashCardDetailArray: flashCardDetailArray,
  };
};

export const submitFlashCardDetails = (
  userFlashcardDetails,
  errorSnackbar = () => {
  },
) => {
  return {
    type: USER_FLASHCARD_DETAILS,
    userFlashcardDetails: userFlashcardDetails,
    errorSnackbar,
  };
};

export const flashCardIndex = (cardIndex) => {
  return {
    type: FLASHCARD_INDEX,
    cardIndex: cardIndex,
  };
};

export const resetFlashCards = (resetFlashCardArray) => {
  return {
    type: RESET_FLASHCARD,
    resetFlashCardArray: resetFlashCardArray,
  };
};
